import { apiFetcher } from './api'

interface FetcherOptions {
  auth?: boolean
}
export async function apiAllFetcher<T>(endpoints: string[], opts: FetcherOptions = {}): Promise<T[]> {
  return await Promise.all(endpoints.map(endpoint => apiFetcher(endpoint, opts) as Promise<T>))
}
